export default __webpack_public_path__ + "static/media/behance-original.92ffdc6e.svg";